import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="border-t border-sage-800 pt-10 mt-10 pb-6" data-id="element-16">
        <p className="mb-6 max-w-4xl mx-auto leading-relaxed text-sm text-sage-400 text-center" data-id="element-17">
          AVISO LEGAL: Este libro se presenta únicamente con fines informativos
          y educativos. No constituye asesoramiento médico, diagnóstico ni
          tratamiento. La lectora asume toda la responsabilidad por cualquier
          acción que tome basada en el contenido. No se garantizan resultados
          específicos. Antes de iniciar cualquier dieta, cambio alimenticio o
          programa de salud, consulta con un profesional médico.
        </p>

        <div className="flex items-center justify-center gap-6 mb-6" data-id="element-18">
          <button onClick={() => setShowPrivacy(true)} className="text-sage-300 hover:text-white text-base font-medium underline underline-offset-4 transition-colors cursor-pointer" data-id="element-19">
            Política de Privacidad
          </button>
          <span className="text-sage-600" data-id="element-20">|</span>
          <button onClick={() => setShowTerms(true)} className="text-sage-300 hover:text-white text-base font-medium underline underline-offset-4 transition-colors cursor-pointer" data-id="element-21">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-base text-sage-400 text-center" data-id="element-22">
          © {new Date().getFullYear()} Método Vientre Plano 55+. Todos los
          derechos reservados.
        </p>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-23">
        <p className="font-semibold text-sage-900 text-lg" data-id="element-24">
          Última actualización: Abril 2026
        </p>

        <p data-id="element-25">
          En Método Vientre Plano 55+ ("nosotros", "nuestro"), respetamos tu
          privacidad y nos comprometemos a proteger tu información personal.
          Esta política describe cómo recopilamos, usamos y protegemos tus
          datos.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-26">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-27">
          Cuando realizas una compra o te suscribes a nuestro contenido, podemos
          recopilar:
        </p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-28">
          <li data-id="element-29">Nombre completo</li>
          <li data-id="element-30">Dirección de correo electrónico</li>
          <li data-id="element-31">
            Información de pago (procesada de forma segura por terceros como
            Hotmart)
          </li>
        </ul>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-32">
          2. Uso de la Información
        </h3>
        <p data-id="element-33">Utilizamos tu información para:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-34">
          <li data-id="element-35">Procesar y entregar tu compra digital</li>
          <li data-id="element-36">Enviarte actualizaciones relacionadas con tu producto</li>
          <li data-id="element-37">Mejorar nuestros servicios y contenido</li>
        </ul>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-38">
          3. Protección de Datos
        </h3>
        <p data-id="element-39">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-40">4. Terceros</h3>
        <p data-id="element-41">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          asisten en la operación de nuestro negocio (procesadores de pago,
          plataformas de email).
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-42">5. Cookies</h3>
        <p data-id="element-43">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y con fines analíticos. Puedes desactivar las cookies en la
          configuración de tu navegador.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-44">
          6. Tus Derechos
        </h3>
        <p data-id="element-45">
          Tienes derecho a acceder, corregir o eliminar tu información personal
          en cualquier momento. Para ejercer estos derechos, contáctanos a
          través de los canales disponibles en nuestra plataforma de venta.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-46">
        <p className="font-semibold text-sage-900 text-lg" data-id="element-47">
          Última actualización: Abril 2026
        </p>

        <p data-id="element-48">
          Al adquirir y utilizar el producto digital "Método Vientre Plano 55+",
          aceptas los siguientes términos y condiciones.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-49">
          1. Naturaleza del Producto
        </h3>
        <p data-id="element-50">
          Este es un producto digital informativo y educativo en formato PDF. No
          constituye asesoramiento médico, diagnóstico ni tratamiento
          profesional. Siempre consulta con un profesional de la salud antes de
          realizar cambios en tu dieta o estilo de vida.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-51">
          2. Entrega del Producto
        </h3>
        <p data-id="element-52">
          El acceso al producto digital se entrega de forma inmediata tras la
          confirmación del pago a través de la plataforma Hotmart. Recibirás un
          enlace de descarga en tu correo electrónico.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-53">
          3. Política de Reembolso
        </h3>
        <p data-id="element-54">
          Ofrecemos una garantía de satisfacción de 7 días. Si no estás
          satisfecha con el producto, puedes solicitar un reembolso completo
          dentro de los 7 días posteriores a la compra, sin preguntas.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-55">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-56">
          Todo el contenido del ebook, incluyendo textos, gráficos, diseños y
          metodologías, está protegido por derechos de autor. Queda prohibida la
          reproducción, distribución o reventa total o parcial del contenido sin
          autorización expresa por escrito.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-57">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-58">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos. La lectora asume toda la responsabilidad por
          las acciones que tome basándose en el contenido del producto.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-59">
          6. Uso Personal
        </h3>
        <p data-id="element-60">
          La licencia de compra es para uso personal e individual. No está
          permitido compartir, copiar o distribuir el material a terceros.
        </p>

        <h3 className="text-lg font-bold text-sage-900 mt-4" data-id="element-61">
          7. Modificaciones
        </h3>
        <p data-id="element-62">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
      </LegalModal>
    </>;
}